import { Image } from 'components/Image'
import { memo, useId } from 'react'
import { TRUST_MARKER_IMAGES } from './constants'

const TrustpilotCard = memo(({ trustMarker, type }) => {
  const { totalRating = 4.6, totalReviews = 1000 } = trustMarker || {}
  const imageSrc = TRUST_MARKER_IMAGES[type?.key] || TRUST_MARKER_IMAGES.trustpilot
  const gradientId = useId()

  return (
    <div
      className={`w-[100px] h-auto sm:w-[164px] sm:h-[105px] py-2 bg-[#f0f4fc] rounded-md border border-solid border-[#154199] text-center absolute ${type?.position} z-10`}
    >
      <div className="flex items-center justify-center space-x-2">
        <Image
          src={imageSrc}
          className="w-full h-[15px] sm:h-[21px]"
          height={24}
          width={140}
          alt={type?.key}
        />
      </div>
      <div className="flex justify-center items-center space-x-1 mb-1">
        {Array.from({ length: totalRating }).map((_, i) => (
          <svg key={i} className="w-3 h-3 sm:w-6 sm:h-6 fill-[#00b67a]" viewBox="0 0 24 24">
            <path d="M12 .587l3.668 7.431L24 9.587l-6 5.843L19.335 24 12 19.771 4.665 24 6 15.43 0 9.587l8.332-1.569z" />
          </svg>
        ))}
        <svg className="w-3 h-4 sm:w-6 sm:h-6 fill-[#00b67a]" viewBox="0 0 24 24">
          <defs>
            <linearGradient id={gradientId}>
              <stop offset="50%" stopColor="#00b67a" />
              <stop offset="50%" stopColor="#dcdcdc" />
            </linearGradient>
          </defs>
          <path
            d="M12 .587l3.668 7.431L24 9.587l-6 5.843L19.335 24 12 19.771 4.665 24 6 15.43 0 9.587l8.332-1.569z"
            fill={`url(#${gradientId})`}
          />
        </svg>
      </div>
      <div className="sm:text-sm text-[8px] text-gray-800 font-medium">
        {totalRating}/5 • <span className="font-semibold">{totalReviews}+</span> reviews
      </div>
    </div>
  )
})
TrustpilotCard.displayName = 'TrustpilotCard'

export { TrustpilotCard }
